export default defineNuxtRouteMiddleware((to, from) => {
  // Check for the double slashes in the URL
  if (to.fullPath.includes('//')) {
    return navigateTo('/', { redirectCode: 301 })
  }
})
